import React from 'react';


function DlgGraficoEvolucaoPostos() {
  return (
    <>
      <iframe width="100%" height="100%" style={{ border:'none' }} src="https://bi.unidatanet.com.br/VLI/#/pages/itemGraficoEvolucaoPostos?url="></iframe>
    </>
  );
}


export default DlgGraficoEvolucaoPostos;
